import axios from "axios";

 const axiosSettings = () =>
  axios.create({
    baseURL: "https://cet-signup.herokuapp.com/",
    // baseURL: "http://localhost:3000/",
    // baseURL: "https://cet-signup-staging.herokuapp.com/",
    headers: {
      "Content-Type": "application/json",
    },
  });

export const getMethod = async (url) => {
  const response = await axiosSettings().get(url);
  return response;
};

export const postMethod = async (url, object) => {
  const response = await axiosSettings().post(url, object);
  return response.data;
};

export const deleteMethod = async (url) => {
  const response = await axiosSettings().delete(url);
  return response.data;
};

export const putMethod = async (url, object) => {
  const response = await axiosSettings().put(url, object);
  return response.data;
};
